import { FormPautas } from "../../components/FormPautas"
import { PautasProvider } from "../../hooks/usePautas"
import { useParams, useLocation } from "react-router-dom"

export function PagePautas() {
  const { id } = useParams<{ id: string }>()
  const location = useLocation()

  return (
    <PautasProvider>
      <FormPautas
        idPauta={id}
        visualizar={location.pathname.includes('visualizar')}
      />
    </PautasProvider>
  )
}
